export const VAT_STORAGE_KEY = 'woodies-show-vat';
export const DEFAULT_CURRENCY = 'EUR';
export const DEFAULT_SYMBOL = '€';
